import { type UseQueryResult, useQuery } from '@tanstack/react-query'
import type { components } from 'api/playerPayback/api'
import { useTypedApiClient } from 'hooks/useTypedApiClient'

export const useGetPatronCheckInProgressForBadge = ({
  patronId,
  badgeRewardId,
}: {
  patronId: number
  badgeRewardId: number
}): UseQueryResult<Array<components['schemas']['FullPatronCheckInDTO']>> => {
  const get = useTypedApiClient({
    path: '/admin/patrons/{patronId}/checkInBadgeProgress/{badgeRewardId}',
    method: 'get',
  })

  return useQuery({
    queryKey: [
      '/admin/patrons/{patronId}/checkInBadgeProgress/{badgeRewardId}',
      patronId,
      badgeRewardId,
    ],
    queryFn: async () => {
      const { data } = await get({ patronId, badgeRewardId })
      return data
    },
  })
}
